import { render, staticRenderFns } from "./UIExpandRow.vue?vue&type=template&id=3b1559c6&scoped=true"
import script from "./UIExpandRow.vue?vue&type=script&lang=js"
export * from "./UIExpandRow.vue?vue&type=script&lang=js"
import style0 from "./UIExpandRow.vue?vue&type=style&index=0&id=3b1559c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1559c6",
  null
  
)

export default component.exports